module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1044-d8c93422f12aef561720bc550e6ce807.png";